import React, { useMemo, useState } from "react";
import {
	Container,
	ModuleContainer,
	Section,
	SubGrid,
	DetailHead,
	DetailHeadLeft,
	DetailIconWrap,
	DetailEyebrow,
	DetailTitle,
	DetailDesc,
	DetailActions,
	SecondaryPill,
	CardIconWrap,
	CardTitle,
	CardDesc,
	CardArrow,
} from "./styles";
import {
	MdBusinessCenter,
	MdOutlineBusiness,
	MdOutlineMessage,
	MdSettingsSuggest,
	MdTrackChanges,
	MdTune,
} from "react-icons/md";
import { Link } from "react-router-dom";
import {
	ApartmentOutlined,
	ClusterOutlined,
	CopyOutlined,
	DatabaseOutlined,
	ExperimentOutlined,
	GoldOutlined,
	IdcardOutlined,
	LockOutlined,
	SearchOutlined,
	StockOutlined,
	TeamOutlined,
} from "@ant-design/icons";
import { CONSTANTS } from "../../../../../../utils/constants";
import { IoGitNetworkOutline } from "react-icons/io5";
import { GiArtificialIntelligence, GiComputing } from "react-icons/gi";
import { Badge } from "antd";
import { BiBox } from "react-icons/bi";
import { COLORS } from "../../../../../layout/theme";

export default function ModuleOneTransfer({
	userdata,
	agentOrdersQty,
	activeSection,
}) {
	const iaItems = useMemo(
		() => [
			{
				to: "/admin/laboratorySuggestions?uri=generalConfig",
				title: "Config. Sugeridos",
				desc: "Parámetros para generación de sugeridos",
				icon: <MdTune size={16} />,
			},
			{
				to: "/admin/suggestedProducts?uri=generalConfig",
				title: "Listado de Sugeridos",
				desc: "Visualización de sugeridos por PDV",
				icon: <StockOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/agentPool?uri=generalConfig",
				title: "PDVs Agente",
				desc: "Puntos de venta con agente IA activo",
				icon: <MdTrackChanges size={16} />,
			},
			{
				to: "/admin/agentConversations?uri=generalConfig",
				title: "Conversaciones Agente",
				desc: "Historial de conversaciones",
				icon: <MdOutlineMessage size={16} />,
			},
			{
				to: "/admin/agentOrders?uri=generalConfig",
				title: "Pedidos Agente",
				desc: "Pedidos gestionados por el agente",
				icon: <BiBox size={16} />,
				badge: agentOrdersQty,
			},
			{
				to: "/admin/agentConfigs?uri=generalConfig",
				title: "Config. Agente",
				desc: "Parámetros de configuracion de agentes",
				icon: <MdSettingsSuggest size={16} />,
			},
			{
				to: "/admin/agentPanel?uri=generalConfig",
				title: "Panel Agentes",
				desc: "Panel de creacion de agentes",
				icon: <GiArtificialIntelligence size={16} />,
			},
			{
				to: "/admin/agentTemplates?uri=generalConfig",
				title: "Config. Plantillas",
				desc: "Gestión de plantillas del agente",
				icon: <GiComputing size={16} />,
			},
		],
		[agentOrdersQty],
	);

	const businessItems = useMemo(
		() => [
			{
				to: "/admin/distributors?uri=generalConfig",
				title: "Droguerías",
				desc: "Configuración y administración de droguerías",
				icon: <ApartmentOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/distributorsIndex?uri=generalConfig",
				title: "Distribuidores",
				desc: "Gestión de distribuidores y relaciones",
				icon: <ClusterOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/saledepartments?uri=generalConfig",
				title: "Rubros",
				desc: "Administración de rubros",
				icon: <SearchOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/categories?uri=generalConfig",
				title: "Categorías",
				desc: "Administración de categorías",
				icon: <GoldOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/activeIngredients?uri=generalConfig",
				title: "Principios Activos",
				desc: "Administración de principios activos",
				icon: <ExperimentOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/presentations?uri=generalConfig",
				title: "Presentaciones",
				desc: "Administración de presentaciones",
				icon: <CopyOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/billers?uri=generalConfig",
				title: "Facturadores",
				desc: "Configuración y creacion de facturadores",
				icon: <ClusterOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/administrationAccess?uri=generalConfig",
				title: "Accesos API",
				desc: "Gestión de accesos de integración",
				icon: <CopyOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/administrationKeys?uri=generalConfig",
				title: "Claves API",
				desc: "Administración de credenciales",
				icon: <LockOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/marketAuths?uri=generalConfig",
				title: "Firebase",
				desc: "Configuración de autenticación",
				icon: <TeamOutlined style={{ fontSize: 16 }} />,
			},
		],
		[],
	);

	const generalItems = useMemo(
		() => [
			{
				to: "/admin/clients?uri=generalConfig",
				title: "Clientes",
				desc: "Administrá contratos y configuraciones",
				icon: <DatabaseOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/marketUsers?uri=generalConfig",
				title: "Usuarios",
				desc: "Permisos, roles y accesos al sistema",
				icon: <IdcardOutlined style={{ fontSize: 16 }} />,
			},
			{
				to: "/admin/chains?uri=generalConfig",
				title: "Cadenas",
				desc: "Configuración y creacion de cadenas",
				icon: <IoGitNetworkOutline size={16} />,
			},
		],
		[],
	);

	const panel =
		activeSection === "business"
			? {
					eyebrow: "Negocio",
					title: "Configuración del Negocio",
					desc: "Parámetros generales y configuración de la empresa",
					icon: <MdBusinessCenter size={20} />,
					iconBg: COLORS.LightSecondary, //"#EEEDFE",
					iconColor: COLORS.Secondary, //"#534AB7",
					items: businessItems,
				}
			: activeSection === "ia"
				? {
						eyebrow: "IA",
						title: "Inteligencia Artificial",
						desc: "Configuración de aplicaciones y agentes de IA del sistema",
						icon: <GiArtificialIntelligence size={20} />,
						iconBg: COLORS.LightDefault, //"#FAECE7",
						iconColor: COLORS.Default, //"#993C1D",
						items: iaItems,
					}
				: {
						eyebrow: "Configuración General",
						title: "Administración General",
						desc: "Accesos principales para administrar clientes, usuarios y cadenas",
						icon: <MdOutlineBusiness size={20} />,
						iconBg: "#E6F1FB",
						iconColor: "#185FA5",
						items: generalItems,
					};

	return (
		<Section>
			<DetailHead>
				<DetailHeadLeft>
					<DetailIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
						{panel.icon}
					</DetailIconWrap>

					<div>
						<DetailEyebrow>{panel.eyebrow}</DetailEyebrow>
						<DetailTitle>{panel.title}</DetailTitle>
						<DetailDesc>{panel.desc}</DetailDesc>
					</div>
				</DetailHeadLeft>
			</DetailHead>

			<SubGrid>
				{panel.items.map((item) => (
					<Link
						key={item.to}
						to={item.to}
						style={{ textDecoration: "none", color: "inherit" }}
					>
						<ModuleContainer>
							<Container>
								<Badge
									count={item.badge}
									offset={[8, -4]}
									size="small"
									color="#E24B4A"
								>
									<CardIconWrap $bg={panel.iconBg} $color={panel.iconColor}>
										{item.icon}
									</CardIconWrap>
								</Badge>

								<CardTitle>{item.title}</CardTitle>
								<CardDesc>{item.desc}</CardDesc>
								<CardArrow>Acceder →</CardArrow>
							</Container>
						</ModuleContainer>
					</Link>
				))}
			</SubGrid>
		</Section>
	);
}
